// validationSchemas.js
import * as Yup from "yup";

export const contractValidationSchema = Yup.object({
  pvc_number: Yup.string()
    .required("Please Enter PVC Number")
    .test("unique-pvc", "PVC Number already exists", function (value) {
      if (!value) return true;
      return !contracts.some((contract) => contract.pvc_number == value);
    }),
  pvc_date: Yup.string().required("Please Enter PVC Date"),
  type: Yup.string().required("Please Select Contract Type"),
  client: Yup.string().required("Please Select Contract Client"),
});
export const unitValidationSchema = Yup.object({
  project: Yup.string().required("Please Select Project"),
  phase: Yup.string().required("Please Select Phase"),
  block: Yup.string().required("Please Select Block"),
  units: Yup.array()
    .of(
      Yup.object().shape({
        unitId: Yup.string().required("Unit is required"),
        unit_project: Yup.string(),
        unit_phase: Yup.string(),
        unit_block: Yup.string(),
        unit_nr: Yup.string(),
        unit_floor: Yup.number().default(0),
        unit_sqm: Yup.number().default(0),
        extras: Yup.number().default(0),
        settled_price: Yup.number()
          .min(1, "Price must be greater than 0")
          .required("Price is required"),
      })
    )
    .min(1, "Please select at least one unit"),
});
export const paymentValidationSchema = Yup.object({
  settled_price: Yup.string(),
  payments: Yup.array()
    .of(
      Yup.object().shape({
        type: Yup.string().required("Please select Payment Type"),
        booking_date: Yup.string().required("Please select Payment Date"),
        unitAmounts: Yup.array()
          .of(
            Yup.object().shape({
              unit_id: Yup.number().required("Unit ID is required"),
              amount: Yup.number()
                .min(1, "Amount must be greater than 0")
                .required("Please enter an amount"),
            })
          )
          .min(1, "At least one unit amount is required"),
      })
    )
    .min(1, "Please add at least one payment"),
  remaining_balance: Yup.number().test(
    "check-remaining-balance",
    "Remaining balance should be 0",
    (value) => value === 0
  ),
});
